import i18next from 'i18next';
import { useTranslation } from 'i18next-vue';

import { AppLocale } from '@shared/i18n';
import cashbackInfoRU from './ru.json';
import cashbackInfoKK from './kk.json';

const NAMESPACE_NAME = 'cashback-info';

export const useCashbackInfoLocales = () => {
  if (i18next.language === AppLocale.RU) {
    i18next.addResourceBundle(
      AppLocale.RU,
      NAMESPACE_NAME,
      cashbackInfoRU,
      true,
    );
  } else {
    i18next.addResourceBundle(
      AppLocale.KK,
      NAMESPACE_NAME,
      cashbackInfoKK,
      true,
    );
  }

  return useTranslation(NAMESPACE_NAME);
};
